import React, { useState } from 'react';
import {
  TextField,
  IconButton,
  InputAdornment,
  TextFieldProps,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

interface PasswordFieldProps extends Omit<TextFieldProps, 'type'> {
  showPassword?: boolean;
  onTogglePassword?: (show: boolean) => void;
}

const PasswordField: React.FC<PasswordFieldProps> = ({
  showPassword: externalShowPassword,
  onTogglePassword,
  ...textFieldProps
}) => {
  const [internalShowPassword, setInternalShowPassword] = useState(false);
  
  // Use external state if provided, otherwise use internal state
  const showPassword = externalShowPassword ?? internalShowPassword;
  
  const handleTogglePassword = () => {
    const newShowPassword = !showPassword;
    
    if (onTogglePassword) {
      onTogglePassword(newShowPassword);
    } else {
      setInternalShowPassword(newShowPassword);
    }
  };

  return (
    <TextField
      {...textFieldProps}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        ...textFieldProps.InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              onClick={handleTogglePassword}
              edge="end"
              size="small"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordField;